// TODO: Consider if we can remove this file's functionality entirely
export default function formatEvent(
  name: string,
  customAttributes: Record<string, any>
) {
  const eventName = Array.isArray(name) ? name.join('_') : name;

  return customAttributes ? { eventName, customAttributes } : { eventName };
}
